import { render, staticRenderFns } from "./rulesTextModal.vue?vue&type=template&id=e392946a&scoped=true&"
import script from "./rulesTextModal.vue?vue&type=script&lang=js&"
export * from "./rulesTextModal.vue?vue&type=script&lang=js&"
import style0 from "./rulesTextModal.vue?vue&type=style&index=0&id=e392946a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e392946a",
  null
  
)

export default component.exports